/**
 * useCanvasStageRef.ts
 * Hook pour accéder au stageRef depuis n'importe quel composant
 * Utilise un service global pour stocker la référence
 */
import { useEffect } from 'react';
import Konva from 'konva';

// Service global pour stocker le stageRef
class CanvasStageRefService {
  private stageRef: React.RefObject<Konva.Stage | null> | null = null;

  setStageRef(ref: React.RefObject<Konva.Stage | null>): void {
    this.stageRef = ref;
  }

  getStageRef(): React.RefObject<Konva.Stage | null> | null {
    return this.stageRef;
  }

  getStage(): Konva.Stage | null {
    return this.stageRef?.current ?? null;
  }
}

export const canvasStageRefService = new CanvasStageRefService();

/**
 * Hook pour enregistrer le stageRef (à utiliser dans CanvasArea)
 */
export function useRegisterCanvasStageRef(stageRef: React.RefObject<Konva.Stage | null>): void {
  useEffect(() => {
    canvasStageRefService.setStageRef(stageRef);
    return () => {
      // Nettoyer à la destruction
      canvasStageRefService.setStageRef({ current: null } as React.RefObject<Konva.Stage | null>);
    };
  }, [stageRef]);
}

/**
 * Hook pour accéder au stageRef depuis n'importe quel composant
 */
export function useCanvasStageRef(): React.RefObject<Konva.Stage | null> | null {
  return canvasStageRefService.getStageRef();
}
